export const environment = {
    firebase: {
        apiKey: "AIzaSyAgoG1VSr_xuwaQIjYx8eLX6CJ0YNiDJaQ",
        authDomain: "coldemailer-8a82d.firebaseapp.com",
        projectId: "coldemailer-8a82d",
        storageBucket: "coldemailer-8a82d.firebasestorage.app",
        messagingSenderId: "156534794005",
        appId: "1:156534794005:web:a48cf6c6aef5cd78d9eb1c"
    },
  };